import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

function createClinicPaymentAbilitiesAndCancelPolicyQueryKey() {
  return [QUERY_KEYS.clinicPaymentAbilitiesAndCancelPolicy];
}

export function useClinicPaymentAbilitiesAndCancelPolicyQuery(options = {}) {
  return useQuery(
    createClinicPaymentAbilitiesAndCancelPolicyQueryKey(),
    () => http.get(HTTP_ENDPOINTS.getClinicPaymentAbilitiesAndCancelPolicy()),
    options,
  );
}
